import service from './Service'
import * as ResultCode from './Result'

/**
 * 查询教师信息
 * @returns 
 */
export function doReqeustTeacherInfo() {
    return new Promise((resolve, reject) => {
        service.teacher({
            url: '/v1/user',
            method: "get",
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 查询教师邀请统计
 * @returns 
 */
export function doReqeustTeacherInvitations() {
    return new Promise((resolve, reject) => {
        service.teacher({
            url: '/v1/user/invitations',
            method: "get",
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}


/**
 * 教师发送验证码
 * @param {*} mobile 
 * @returns 
 */
export function doRequestTeacherSendVerificationCode(mobile = '') {
    return new Promise((resolve, reject) => {
        service.teacher({
            url: `/v1/user/${mobile}/verification/inv/send`,
            method: "put",
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 教师邀请教师
 * @param {*} mobile 
 * @param {*} code 
 * @param {*} userId 
 * @param {*} invitationType 
 * @returns 
 */
export function doReqeustTeacherInvitationTeacher(mobile = '', code = '', userId = '', invitationType = 1001) {
    return new Promise((resolve, reject) => {
        service.teacher({
            url: '/v1/user/invitation/teacher',
            method: "post",
            data: {
                mobile,
                code,
                userId,
                invitationType
            }
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}


/**
 * 教师邀请学生加入班级
 * @param {*} mobile 
 * @param {*} code 
 * @param {*} userId 
 * @param {*} classId 
 * @returns 
 */
export function doReqeustTeacherInvitationStudentToJoinClass(mobile = '', code = '', userId = '', classId = 0) {
    return new Promise((resolve, reject) => {
        service.teacher({
            url: '/v1/user/invitation/student',
            method: "post",
            data: {
                mobile,
                code,
                userId,
                classId,
                'invitationType': 1001
            }
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}


// --------------------- 学生 ---------------------

/**
 * 查询学生信息
 * @returns 
 */
export function doReqeustStudentInfo() {
    return new Promise((resolve, reject) => {
        service.student({
            url: '/v1/user',
            method: "get",
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 查询学生邀请统计
 * @returns 
 */
export function doReqeustStudentInvitations() {
    return new Promise((resolve, reject) => {
        service.student({
            url: '/v1/user/invitations',
            method: "get",
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 教师发送验证码
 * @param {*} mobile 
 * @returns 
 */
export function doRequestStudentSendVerificationCode(mobile = '') {
    return new Promise((resolve, reject) => {
        service.student({
            url: `/v1/user/${mobile}/verification/inv/send`,
            method: "put",
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

/**
 * 教师邀请教师
 * @param {*} mobile 
 * @param {*} code 
 * @param {*} userId 
 * @param {*} invitationType 
 * @returns 
 */
export function doReqeustStudentInvitationStudent(mobile = '', code = '', userId = '', invitationType = 1001) {
    return new Promise((resolve, reject) => {
        service.student({
            url: '/v1/user/invitation/student',
            method: "post",
            data: {
                mobile,
                code,
                userId,
                invitationType
            }
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/Invitation.js